export type GetStripeSetupIntentPayload = {
  uuid: string
}

export type GetStripeSetupIntentResponse = {
  stripe_setup_intent_client_secret: string
}

export async function getStripeSetupIntentClientSecret({
  uuid,
}: GetStripeSetupIntentPayload): Promise<{
  data: string
  error?: string
}> {
  const query = `
    query GET_STRIPE_SETUP_INTENT_CLIENT_SECRET($uuid: String!) {
      get_stripe_setup_intent_client_secret(uuid: $uuid)
    }
  `

  const res = await fetch(import.meta.env.VITE_PURCHASE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      query,
      variables: { uuid },
      operationName: 'GET_STRIPE_SETUP_INTENT_CLIENT_SECRET',
    }),
  })

  const json = await res.json()

  if (json.errors?.length) {
    throw new Error(`${json.errors[0].message}. Code: get_stripe_setup_intent_client_secret`)
  }

  const secret = json?.data?.get_stripe_setup_intent_client_secret?.stripe_setup_intent_client_secret

  return {
    data: secret,
    error: !secret ? 'Unable to retrieve Stripe client secret' : undefined,
  }
}

